"use client";

import { useEffect, useState } from "react";

const DISMISS_KEY = "onomac-app-banner-dismissed";

/**
 * ASO Smart Banner — mobil uygulama yayına girince aktifleşir.
 * Uygulama ID'leri tanımlı değilse hiç render edilmez (şu an pasif).
 * Gerekli ENV: NEXT_PUBLIC_IOS_APP_ID, NEXT_PUBLIC_ANDROID_PACKAGE
 */
export function SmartAppBanner() {
  const iosId = process.env.NEXT_PUBLIC_IOS_APP_ID;
  const androidPkg = process.env.NEXT_PUBLIC_ANDROID_PACKAGE;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!iosId && !androidPkg) return;
    try {
      if (localStorage.getItem(DISMISS_KEY)) return;
    } catch {
      return;
    }
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      (navigator as Navigator & { standalone?: boolean }).standalone === true;
    // eslint-disable-next-line react-hooks/set-state-in-effect
    if (isMobile && !isStandalone) setVisible(true);
  }, [iosId, androidPkg]);

  if (!visible || (!iosId && !androidPkg)) return null;

  const isIOS = /iPhone|iPad|iPod/i.test(typeof navigator !== "undefined" ? navigator.userAgent : "");
  const storeUrl =
    isIOS && iosId
      ? `https://apps.apple.com/app/id${iosId}`
      : androidPkg
        ? `https://play.google.com/store/apps/details?id=${androidPkg}`
        : "#";

  const dismiss = () => {
    try {
      localStorage.setItem(DISMISS_KEY, "1");
    } catch {}
    setVisible(false);
  };

  return (
    <div className="sticky top-0 z-40 flex items-center gap-3 bg-Primary-dark px-4 py-2.5 text-white sm:hidden" role="banner" aria-label="Mobil uygulama indir">
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-Primary to-Primary-dark font-serif font-bold shadow">
        O
      </span>
      <div className="min-w-0 flex-1">
        <p className="truncate text-[13px] font-semibold">Ono MAC Uygulaması</p>
        <p className="truncate text-xs text-White/70">İndir, ilk siparişte %15 kazan</p>
      </div>
      <a
        href={storeUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="shrink-0 rounded-full bg-white px-4 py-2 text-xs font-bold text-Primary-dark"
      >
        İndir
      </a>
      <button onClick={dismiss} aria-label="Bannerı kapat" className="shrink-0 rounded-full p-1.5 text-zinc-400 hover:text-white">
        ✕
      </button>
    </div>
  );
}
